const slugifyLib = require('slugify');

export default function slugify(text: string): string {
    return slugifyLib(text, {
        lower: true,
        remove: /[*+~.()'"!:@\/]/g
    });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/utils/url/slugify.ts